// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| LPG LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <svg
      width="129"
      height="129"
      viewBox="0 0 129 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Cylinder Body */}
      <rect
        x="30"
        y="36"
        width="69"
        height="70"
        rx="10"
        fill={theme.vars.palette.primary.main}
      />

      {/* Cylinder Top */}
      <rect
        x="46"
        y="22"
        width="37"
        height="18"
        rx="5"
        fill={theme.vars.palette.primary.dark}
      />

      {/* Flame */}
      <path
        d="M64.5 50C58 58 54 63 54 70.5C54 80 60.5 88 64.5 88C68.5 88 75 80 75 70.5C75 63 71 58 64.5 50Z"
        fill={theme.vars.palette.warning.main}
      />
    </svg>
  );
}
